import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import TimeSlot from '../ReserveCom/TimeSlot';  // TimeSlotコンポーネントを作成する必要があります
import { LuCigaretteOff } from "react-icons/lu";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom';


const MypagePaymentContainer = (props) => {
  const [reservations, setReservations] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get('/api/medichat/reservations', {
      headers: {
        'uid': props.token,  // ここにアクセストークンをしっかり渡す
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setReservations(response.data);
        setIsLoading(false);
        console.log(response.data)
      });
  }, []);

  const DateTimeComponent = ({ isoDate }) => {
    const date = new Date(isoDate);
    
    // 月/日/曜日/何時/何分 のフォーマットを作成
    const formattedDate = date.toLocaleDateString('ja-JP', {
        month: '2-digit', // 月
        day: '2-digit',   // 日
        weekday: 'short', // 曜日
    });
    
    const formattedTime = date.toLocaleTimeString('ja-JP', {
        hour: '2-digit',   // 何時
        minute: '2-digit', // 何分
    });
    
    return (
        <div>
        <p>{`${formattedDate} ${formattedTime}`}~</p>
        </div>
    );
};

if (isLoading) {
  return (
    <div>
      <div className="loader" style={{ width: '100px', height: '100px' }}></div>
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: '0%',
          height: '80px',
          background: '#FEFBF9',
          zIndex: '12',
        }}
      />
    </div>
  );
}
  return (
    <div className="sunny_container">
    <div className="mypage_reservation container">
      <h1 className="mypage_reservation_h1">お支払い待ちの診察一覧</h1>
      {reservations.map((item, index) => (
          <div className="mypage_reservation_content">
            <div className="mypage_reservation_content_upper">
            <p className="mypage_reservation_content_upper_title"><LuCigaretteOff />痛風治療</p>
            {
              item.subject_id == 2 &&
              <p className="mypage_reservation_content_upper_title">肥満治療</p>
            }
            {
              item.subject_id == 1 &&
              <p className="mypage_reservation_content_upper_title">高血圧</p>
            }
            <p className="mypage_reservation_content_upper_time"><DateTimeComponent isoDate={item.start_time} /></p>
            <p className="mypage_reservation_content_upper_label">初診</p>
            </div>
            {
              item.confirm_status ?
              <NavLink to={`/mypage/payment/bill/${item.id}`} className="mypage_reservation_content_lower">
                <button className="mypage_reservation_content_lower_button">お支払いへ</button>
              </NavLink>
              :
              <div className="mypage_reservation_content_lower">
                <button style={{background: 'grey'}} className="mypage_reservation_content_lower_button">お会計確定までお待ちください</button>
              </div>
            }
          </div>  // keyには一意な値を設定する
        ))}
    </div>
    </div>
  );
};

export default MypagePaymentContainer;
